import { useEffect } from 'react';
import { useTour } from '@reactour/tour';
import { useOnboardingQueryParam } from 'root/src/client/v2/onboarding/hooks/useOnboardingQueryParam';
import { RedesignOnboardingStep } from 'root/src/client/v2/onboarding/redesign/RedesignOnboardingStep';
export const DROP_ONBOARDING_STEPS = [
    {
        selector: '[data-onboarding="drop-countdown"]',
        position: 'bottom',
        content: (<RedesignOnboardingStep>
				<div>
					<p className="font-display text-base font-semibold text-foreground">Countdown</p>
					<p className="mt-1 text-sm text-muted-foreground">See how much time is left to join this Drop before it ends.</p>
				</div>
			</RedesignOnboardingStep>),
    },
    {
        selector: '#dares',
        position: 'top',
        content: (<RedesignOnboardingStep>
				<div>
					<p className="font-display text-base font-semibold text-foreground">Accept a Dare</p>
					<p className="mt-1 text-sm text-muted-foreground">Pick a dare, stream the game, and earn rewards for you and your viewers.</p>
				</div>
			</RedesignOnboardingStep>),
    },
];
// Opens the onboarding tour when the drop page is visited with ?onboarding=true. Rendered
// inside the page's TourProvider; returns nothing (it only drives the tour).
export const DropOnboarding = () => {
    const [isOnboarding] = useOnboardingQueryParam();
    const tour = useTour();
    useEffect(() => {
        var _a;
        if (isOnboarding) {
            (_a = tour.setSteps) === null || _a === void 0 ? void 0 : _a.call(tour, DROP_ONBOARDING_STEPS);
            tour.setIsOpen(true);
        }
    }, [isOnboarding]);
    return null;
};
